export default "__VITE_ASSET__4614bcfb__"